const PAGE_NAME = 'Codeword';
const INFO_EMAIL = 'info@younghollywood.com';
const IMAGE_SCENE_TITLE = 'Scene and Frame Detection';
const IMAGE_SCENE_DETAIL =
  'Show and highlight the precise moments in the video where your search term appears or is mentioned';
const TRANSCRIPTION_SCENE_TITLE = 'Audio talks about your search';
const TRANSCRIPTION_SCENE_DETAIL =
  'Show videos where the audio tracks for mentions of your search term, helping you find relevant content based on what is being said';
const DESCRIPTION_SCENE_TITLE = 'Video Description Search';
const DESCRIPTION_SCENE_DETAIL =
  'Show results which descriptions or tags match your search term, they always redirect to the start of the video';
const VIEW_MORE_RESULTS = 'view more results';
const NEW_ICON_TEXT = 'New';
const ABOUT_US_TITLE = 'About us';
// Vanja's copy for /about-us, supplied verbatim by email 2026-08-28. Client
// marketing copy: do not reword, resplit or repunctuate it.
//
// The heading is deliberately NOT ABOUT_US_TITLE. She supplied "About Codeword"
// as the page heading while the footer link stays "About us"; whether the link
// label should follow is her call and has been asked, not decided here.
const ABOUT_CODEWORD_HEADING = 'About Codeword';
const ABOUT_CODEWORD_BODY =
  'Codeword, owned and operated by Young Hollywood LLC, is an AI-powered, rights-managed marketplace for premium, hard-to-find video. Buyers can search inside footage, find exact moments, and license only the seconds they need, while rights holders can organize, control, and monetize valuable media archives.';
const PRIVACY_POLICY_TITLE = 'Privacy Policy';
const TERMS_AND_CONDITIONS_TITLE = 'Terms and Conditions';
const COPYRIGHT_TEXT = 'Copyright © 2026 Young Hollywood LLC';
const BACK_TEXT = 'Back';
const BACK_HOME_TEXT = 'Back Home';
// RJ's revised homepage (20 Oct), the font guide's two hero rows.
const TITLE_HOME_P1 = 'Find the exact moment.';
const TITLE_HOME_P2 = 'License it. Create with it.';
const WAVE_TEXT = '~~~~~~~~~~';
const RESULTS = 'RESULTS';
const NO_RESULTS = 'NO RESULTS';
const NO_RESULTS_MSG = `We couldn't find any videos matching your search. Try refining your keywords to discover more.`;
const TOP_PICKS = 'TOP PICKS FOR YOU';
const BROWSE_COLLECTIONS_TITLE = 'Browse Collections';
// The Trending row's heading. When the row is off or its request fails, the
// row and this heading are not shown at all (2026-10-14).
const TRENDING_TITLE = 'Trending';
// Category collection page. Plain language, no internal vocabulary: a visitor
// has no idea what a "collection" is in our data model, only what the section on
// the home page is called.
const COLLECTION_BACK_TEXT = 'Back to home';
const COLLECTION_VIDEO_SINGULAR_TEXT = 'video';
const COLLECTION_VIDEO_PLURAL_TEXT = 'videos';
// Used when the response comes back exactly at the API ceiling. It deliberately
// names no number: the envelope carries no total, so "50 of 120" is not
// something we are able to say truthfully.
const COLLECTION_SHOWING_RECENT_TEXT = 'Showing the most recent videos in this collection';
const COLLECTION_EMPTY_TITLE_TEXT = 'Nothing here yet';
const COLLECTION_EMPTY_MSG_TEXT =
  'This collection does not have any videos at the moment. Please check back soon.';
const COLLECTION_NOT_FOUND_TITLE_TEXT = 'Collection not found';
const COLLECTION_NOT_FOUND_MSG_TEXT =
  'That collection does not exist. You can browse the collections on the home page instead.';
const COLLECTION_ERROR_TITLE_TEXT = 'Collection could not be loaded';
const COLLECTION_ERROR_MSG_TEXT =
  'These videos could not be loaded right now. You can try again.';
// Accessible name for a category tile, composed as "View Music videos". The
// visible tile shows only the category name, which on its own would reach a
// screen reader as an unlabelled button.
const COLLECTION_TILE_ACTION_PREFIX_TEXT = 'View';
const COLLECTION_TILE_ACTION_SUFFIX_TEXT = 'videos';
// The search placeholder of RJ's revised homepage mockup (20 Oct).
const SEARCH_BAR_MSG = 'Search dialogue, people, actions, objects, and moments...';
// Shown under the search box while the text is too short to search (Vanja,
// 2026-09-28, item 8: "AJ" could not be searched). Called with MIN_TEXT_LENGTH,
// so the number shown is always the rule enforced. Wording pending Vanja's
// approval.
const SEARCH_MIN_LENGTH_HINT = (minLength: number): string =>
  `Type at least ${minLength} characters to search.`;
const INVALID_SEARCH_DETECTED_TEXT = 'Invalid Search detected';
const INVALID_SEARCH_MSG = `It looks like your search input isn't valid. Please ensure you're entering appropriate search terms.`;
const NOT_COMPLETED_REQUEST = 'Search Error';
const NOT_COMPLETED_REQUEST_MSG = 'The server encountered an error and could not complete your request. Please try your search again.';
const SERVICE_UNAVAILABLE = 'Service Unavailable';
const SERVICE_UNAVAILABLE_MSG = 'The search is not available. Please try again, or you can return to the home page.';
// Profile
const DIALOG_DESCRIPTION = `Are you sure you want to log out of Young Hollywood? You'll lose access to play videos and make purchases.`;
const LOGOUT = 'Log out';
const LOGOUT_MSG = 'Are you sure you want to log out? You’ll lose access to play videos and make purchases.';
const MY_INFORMATION = 'My information';
  
const MY_INFORMATION_DESCRIPTION = 'Here you can edit or consult your details';
const MY_INFORMATION_SUBMIT = 'Save';
const MY_ORDERS = 'My orders';
const MY_ORDERS_DESCRIPTION = `Start exploring our catalog to uncover the best videos. Whether it's celebrity events, concerts, or exclusive footage, there's something waiting just for you.`;
const MY_ORDERS_NOTHING_TO_SEE = 'nothing to see here';
const MY_ORDERS_DISCLAIMER_TEXT =
  'Here, you can check and manage your order history, making it easy to revisit your past purchases';
const MY_INFORMATION_INPUTS = {
  NAME: { label: '* Name', placeHolder: 'Enter your first name' },
  LAST_NAME: { label: '* Last name', placeHolder: 'Enter your last name' },
  EMAIL: { label: '* Email', placeHolder: 'Enter your email' },
  PASSWORD: {
    label: '* Password',
    placeHolder: 'Password',
    helperText: `Your password must be 8 to 100 characters, contain uppercase and lowercase letters and at least two numbers, and have no spaces.`,
  },
  COMPANY: { label: '* Company', placeHolder: 'Enter your company' },
};
const PASSWD_MUST_BE_SAME = 'Passwords must be same';
const MY_ORDERS_SUBMIT = 'explore now';
const PAYMENT = 'Payment';
const PROFILE_GREETING = 'Hello 👋';
const PROFILE_TITLE = 'My profile';
const MOST_RECENT_TEXT = 'Most recent';
const OLDEST_TEXT = 'Oldest';
const ORDER_TEXT = 'Order';
const VIEW_DETAILS_TEXT = 'View Details';
const SORT_BY_TEXT = 'Sort by';
const BACK_TO_MY_ORDERS_TEXT = 'Back to my orders';
const ORDER_DETAIL_TEXT = 'Order detail';
const ORDER_MAIN_COMMENT = `We’ve packaged the video up, all you have to do is click the download button below.<br/><br/>
  Your privacy matters to us; we are not sharing this video with anyone else. <br/>
  If you are having trouble downloading your video, please contact us: <a href="mailto:${INFO_EMAIL}">${INFO_EMAIL}</a>`;
const READY_TEXT = 'Ready';
const LOADING_TEXT = 'Loading';
// PLACEHOLDER WORDING. VANJA OWNS EVERY STRING IN THIS BLOCK. Replace the
// values, keep the names. These are the clip-status line on the orders page,
// under the progress pill, one per state:
//   PAYMENT_CONFIRMING_TEXT  paid on Stripe's page, the webhook has not yet
//                            marked the order COMPLETED
//   CLIP_PREPARING_TEXT      the order is COMPLETED and the clip is being cut,
//                            or a cut failed and will be tried again
//   CLIP_FAILED_TEXT         three cut requests came back without a clip and
//                            nothing further will be tried from this page
//   CLIP_NOT_READY_TEXT      the progress pill's label in that last state
// The previous single line, 'Download will be available in around 5 seconds',
// promised a time nothing measured and stayed on screen after the cut had
// failed for good. No duration is quoted in any of these on purpose.
const PAYMENT_CONFIRMING_TEXT = 'We are confirming your payment.';
const CLIP_PREPARING_TEXT = 'We are preparing your clip. This can take a few minutes.';
const CLIP_FAILED_TEXT =
  `We could not prepare your clip. Your payment has been received. Please contact ${INFO_EMAIL} and quote your confirmation number.`;
const CLIP_NOT_READY_TEXT = 'Not ready';
const DOWNLOAD_VIDEO_TEXT = 'Download video';
const CONTRACT_LICENSING_TEXT = 'Contract Licensing';
const CONTRACT_LICENSING_DISCLAIMER_TEXT = 'Here you can consult and download your contract';
const VIEW_TEXT = 'View';
// The signed contract on the order page (2026-10-14). NEW WORDING, written by
// the build session; Vanja owns it. Download uses CONTRACT_DOWNLOAD_TEXT, the
// checkout's own "Download PDF".
//   SIGNED_CONTRACT_MISSING_TEXT   the order has no signed contract on record
//   SIGNED_CONTRACT_FAILED_TEXT    the contract could not be fetched
//   SIGNED_CONTRACT_FILE_NAME      the name the downloaded file is saved under
const SIGNED_CONTRACT_MISSING_TEXT = 'The signed contract for this order is not available.';
const SIGNED_CONTRACT_FAILED_TEXT = 'Your signed contract could not be loaded. Please try again later.';
const SIGNED_CONTRACT_FILE_NAME = (confirmationNumber: string): string =>
  `${confirmationNumber || 'order'}-signed-contract.pdf`;

const BACK_TO_RESULTS_TEXT = 'Back to results';
// "Video ID: <id>" on the video page, on the order summary of the licensing
// page and on the order page under My profile (Joey, 2026-10-13). All three
// read "Item Id" until then.
const VIDEO_ID_TEXT = 'Video ID';
const DESCRIPTION_TEXT = 'Description';
const TAGS_TEXT = 'Tags';
// Video detail page, VPM detail API sections.
const PEOPLE_TEXT = 'People';
const TOPICS_TEXT = 'Topics';
const QUOTES_TEXT = 'Quotes';
const SELECTED_MOMENT_TEXT = 'Selected moment';
// Per-scene people split (2026-08-18, agreed with Igor and RJ): on-camera vs merely
// referenced, so a mentioned-only name isn't shown as if they're on screen.
const IN_THE_VIDEO_TEXT = 'In the video';
const MENTIONED_TEXT = 'Mentioned';
// Overflow toggles on the video detail page. The collapsed face is always the
// count itself ("+49"), built in the component; these cover the expanded face
// and the accessible name a screen reader gets in place of a bare number.
//
// SHOW_LESS_TEXT is deliberately un-prefixed: it is generic UI copy shared by
// the tags row and the people row. Leaving it named TAGS_ while the People chip
// used it would be the same kind of mislabel MY_UPLOADS_COL_LIBRARY_TEXT was.
// The accessible names stay per-feature, because "Show all tags" and "Show all
// people" are the whole point of having them.
const SHOW_LESS_TEXT = 'Show less';
const TAGS_SHOW_ALL_LABEL = 'Show all tags';
const PEOPLE_SHOW_ALL_LABEL = 'Show all people';
const VIDEO_DETAIL_UNAVAILABLE_TEXT = 'Details could not be loaded';
const VIDEO_DETAIL_UNAVAILABLE_MSG =
  'The extra details for this video could not be loaded right now. You can try again.';
const TRY_AGAIN_TEXT = 'Try again';
const VIDEO_STILL_PROCESSING_TEXT = 'This video is still being processed, so some details are not ready yet.';
const VIDEO_PROCESSING_FAILED_TEXT = 'This video could not be processed, so its details are unavailable.';
// Was 'Frames from videos sorted by relevance' - not accurate. This strip is
// video-detail-api's stored keyframe order (interleaved for spread by
// toStripAssets, see api/videoDetail/mapper.ts), not a relevance-ranked
// result: no search query is passed to this endpoint at all (RJ, 2026-08-27).
const FRAMES_FROM_VIDEOS_TEXT = 'Keyframes from this video';
// The badge on a strip thumbnail that stands for several near-identical frames.
const SIMILAR_FRAMES_BADGE = (count: number): string => `+${count} similar`;
const SIMILAR_FRAMES_ARIA_LABEL = (count: number): string =>
  `Show ${count} similar ${count === 1 ? 'frame' : 'frames'}`;
const RESOLUTION_TEXT = 'Resolution';
const MORE_DETAILED_INFORMATION_TEXT =
  'More detailed information about the premium license included in the next step after the purchase';
const FRAME_FOR_VIDEOS_TEXT = 'Frames from videos sorted by relevance';
const FILTER_BY_TEXT = 'Filter by';
const NO_RESULTS_TEXT = 'No results';
const NO_FRAMES_TEXT = 'No frames match your filters. Please try using different filters';
const ALL_SELECTOR_TEXT = 'All';
const VIDEO_SELECTOR_TEXT = 'Video';
const AUDIO_SELECTOR_TEXT = 'Audio';
const TEXT_SELECTOR_TEXT = 'Text';
const USD_CURRENCY = 'USD';
const PRICE_TEXT = 'Price';
const PRICE_LOADING_TEXT = 'Calculating price';
const PRICING_REQUEST_QUOTE_TEXT = 'Pricing available on request';
const PRICING_NOT_LICENSABLE_TEXT = 'Not available for licensing';
const PRICING_UNAVAILABLE_TEXT = 'Pricing unavailable, please try again';
const ORDER_NOT_QUOTABLE_TEXT =
  'This clip is no longer available for licensing at the quoted terms. Please review your selection.';
const ORDER_SUBMIT_FAILED_TEXT = 'We could not complete your order. Please try again.';
const SECONDS_TEXT = 'seconds';
// Singular form for the clip-length line: "1 seconds" read as a bug. Named
// SECOND_SINGULAR_TEXT because SECOND_TEXT is already taken by 'Second'
// (capitalised, an ordinal used elsewhere) and the two are not interchangeable.
const SECOND_SINGULAR_TEXT = 'second';

// Shown under the total ONLY when the selection is under 3 seconds. Names the
// rule so the charge reads as policy, not as a miscalculation. From the memo:
// "Allow 1-2 second selections, but charge a 3-second minimum per licensed
// clip." Sub-3-second selections stay allowed - this explains the charge, it
// does not warn the buyer off.
const BILLABLE_MINIMUM_NOTICE = (billableSeconds: number): string =>
  `Billed at the ${billableSeconds}-second minimum per licensed clip.`;
// THE TWO MANUAL-REVIEW NOTICES.
//
// SINCE 2026-10-13 (Joey, following Young Hollywood's licensing memo) BOTH
// lead to a quote request: where either applies, "Request a quote" stands in
// BUY NOW's place on the price panel (REQUEST_QUOTE_TEXT, below, and
// components/QuoteRequestDialog). The history that follows is why each exists.
//
// DURATION: was NOTICE-ONLY until then, with BUY NOW left enabled, because the
// trigger fires above the served manual_review_after_seconds regardless of
// price and there was no quote form to send a buyer to. There is one now.
//
// VALUE: a BLOCK since a deliberate policy decision of 2026-09-02.
// Above the served manual_review_order_threshold_usd, BUY NOW is disabled and
// the gateway refuses the order (order.service.ts) even if the button is
// bypassed. This REVERSES the earlier notice-only decision recorded here and at
// VideoPricing/index.tsx. The reason for that decision - no quote form exists -
// is still true; refusing money the platform cannot lawfully process was judged
// the better trade. Tay was told.
//
// The value string therefore has to do more work than a notice: it sits beside
// a button the buyer cannot press, so it must say what happens instead. It
// names an address that exists (INFO_EMAIL) and promises no form, no intake and
// no callback, because none of those exist.
//
// Vanja owns this wording. Changing it is changing these strings and nothing
// else - no condition anywhere reads their text.
const MANUAL_REVIEW_DURATION_NOTICE = (limitSeconds: number): string =>
  `Clips over ${limitSeconds} seconds require a quote and manual approval.`;
const MANUAL_REVIEW_VALUE_NOTICE = (thresholdUsd: number): string =>
  `Orders over $${thresholdUsd.toLocaleString('en-US')} are arranged directly rather than `
  + `through checkout. Please contact ${INFO_EMAIL} to license this clip.`;
// The same refusal, seen from the server. Reached only when the panel's block
// was bypassed or the price moved between the panel and the POST: useFetch
// surfaces only the status, so this is keyed on the gateway's 422.
const ORDER_VALUE_LIMIT_TEXT =
  'This licence is above the value we can complete through online checkout. '
  + `Please contact ${INFO_EMAIL} to arrange it directly.`;
const PER_SECOND_TEXT = 'per second';
const TOTAL_TEXT = 'Total';
const STARTING_TEXT = 'Starting';
const FINISHING_TEXT = 'Finishing';
const SELECT_USAGE_TYPE_TEXT = 'Select the usage type for your purchase';
const ALL_MEDIA_TYPE_TEXT = 'All Media';
// The memo's full form, per its own rule ("Use "All Media + Approved
// AI-Assisted Modifications" where space allows; use "AI Mods" in compact UI
// with a tooltip") - the usage chips are the panel's widest text surface.
// The previous value here ('All Media + AI Modifications') matched NO source
// document and round-tripped verbatim into orders and the contract's Exhibit
// A; renamed 2026-08-15 while zero orders exist anywhere (verified live).
const ALL_MEDIA_PLUS_AI_TYPE_TEXT = 'All Media + Approved AI-Assisted Modifications';
const USAGE_TYPE_TEXT = 'Usage Type';
const TERRITORY_TEXT = 'Territory';
// Configurable territories (2026-10): an owner who prices regions and countries lets the buyer pick some of them.
const TERRITORY_CHOOSE_TEXT = 'Choose at least one territory to see the price';
const TERRITORY_HINT_TEXT =
  'Type a country or region. You pay the sum of your picks, never more than the worldwide price. Overlapping picks are not offered.';
const TERRITORY_REGIONS_TEXT = 'Regions';
const TERRITORY_COUNTRIES_TEXT = 'Countries';
const TERRITORY_OVERLAP_TEXT = (name: string) => `Overlaps ${name}: remove it first`;
const TERRITORY_LIMIT_TEXT = (limit: number) => `At most ${limit} territories per licence`;
const TERRITORY_SUM_TEXT = 'Sum of your territories';
const TERRITORY_CAPPED_TEXT = (price: number) => `Capped at the worldwide price: $${price} USD per second`;
const TERRITORY_PICKER_LABEL = 'Territories';
// A configurable owner can also sell plain Worldwide (the legacy option, at the worldwide price). It excludes the picks.
const TERRITORY_USE_WORLDWIDE_TEXT = (price: number) => `Use worldwide, $${price} / s`;
const TERRITORY_SEARCH_WORLDWIDE_TEXT = 'Worldwide includes every territory. Turn it off to pick regions or countries.';
const TERRITORY_WORLDWIDE_INCLUDED_TEXT = 'Worldwide already includes this territory';
// A territory priced above the worldwide price: the buyer pays the worldwide price for it, never more.
const TERRITORY_CHIP_CAPPED_TEXT = (price: number, cap: number) => `$${price} USD per second, capped at $${cap}`;
// The search picker (2026-10): the picks are removable chips, and a search box lists the regions and countries beside them. The compact
// wording is what the eye reads; the longer wording above is what a screen reader is given.
const TERRITORY_SEARCH_LABEL = 'Add a region or country';
const TERRITORY_SEARCH_PLACEHOLDER = 'Search countries and regions';
const TERRITORY_PICKS_LABEL = 'Your territories';
const TERRITORY_REMOVE_TEXT = (name: string) => `Remove ${name}`;
const TERRITORY_PICK_TEXT = (name: string, price: number) => `${name} \u00b7 $${price}`;
const TERRITORY_PICK_CAPPED_TEXT = (name: string, price: number, cap: number) => `${name} \u00b7 $${price}, capped at $${cap}`;
const TERRITORY_ROW_PRICE_TEXT = (price: number) => `$${price} / s`;
const TERRITORY_ROW_PRICE_CAPPED_TEXT = (price: number, cap: number) => `$${price} / s, capped at $${cap}`;
const TERRITORY_REGION_KIND_TEXT = 'Region';
const TERRITORY_COUNTRY_KIND_TEXT = 'Country';
const TERRITORY_COUNTRY_IN_TEXT = (regions: string) => `Country, in ${regions}`;
const TERRITORY_KIND_NOT_OFFERED_TEXT = (kind: string) => `${kind}, not offered by this owner`;
const TERRITORY_KIND_NOT_OFFERED_NOW_TEXT = (kind: string) => `${kind}, not offered for this usage or licence period`;
const TERRITORY_INCLUDED_IN_TEXT = (name: string) => `Included in ${name}`;
const TERRITORY_INCLUDES_TEXT = (name: string) => `Includes ${name}`;
const TERRITORY_ALREADY_ADDED_TEXT = 'Already added';
const TERRITORY_NO_MATCH_TEXT = (query: string) => `No match for "${query}"`;
const TERRITORY_TO_ADD_TEXT = (count: number) => `${count} ${count === 1 ? 'territory' : 'territories'} to add`;
const PERIOD_TEXT = 'Period';
const PERIOD_DISCLAIMER =
  'Period refers to the duration for which you have the rights to own and use the video';
const DOMESTIC_TEXT = 'Domestic (Only USA)';
const DOMESTIC_AND_WORLDWIDE_TEXT = 'Domestic and Worldwide';
const PERPETUITY_TEXT = 'Perpetuity';
const ONE_YEAR_TEXT = '1 Year';
const BUY_NOW_TEXT = 'Buy Now';
const LICENSE_DISCLAIMER_TEXT = 'This license allows AI-generated modifications to the video';
// Memo §4 "AI restriction", verbatim. Rendered with the permissive line above
// in the usage tooltip, so selecting the AI option states what it excludes,
// not only what it allows. The same paragraph belongs in the licence
// agreement. The app held that as a placeholder text file until 2026-10-13,
// when the file was removed; that half ships with the real agreement, not
// from here.
const AI_USAGE_RESTRICTION_TEXT =
  'The AI option does not include model training, fine-tuning, face or voice cloning, synthetic endorsements, digital replicas, biometric identification, or deceptive edits unless separately approved in writing.';
// Memo §4 "Recommended tooltip", verbatim. The previous copy here said the
// buyer gets "the rights to own and use the video" - the exact thing the memo
// (and the licence agreement) deny. These sentences carry their own final
// periods; the render site must not append one.
const PERIOD_DISCLAIMER_TEXT =
  'Period refers to how long the licensed clip may remain in the approved production. Copyright and ownership remain with the content owner.';
// Memo §4 "Perpetuity copy", verbatim. Shown only while Perpetuity is the
// selected period - it is the sentence that stops a buyer reading a perpetual
// licence as a transfer of ownership.
const PERPETUITY_DISCLAIMER_TEXT =
  'Perpetuity means the licensed clip may remain in the approved production forever. It does not transfer ownership, copyright, or unlimited reuse rights.';
// Accessible name for the button that reveals the two sentences above. The
// copy moved behind a hover on 2026-08-28 (Vanja), and a control that only
// reveals on hover is invisible to a screen reader without a name of its own.
const PERIOD_DISCLAIMER_LABEL = 'About the licence period';
const SD = 'SD';
const HD = 'HD';
const FULL_HD = 'Full HD';
const FOUR_K = '4K';
const VIDEO_NOT_FOUND_TEXT = 'Video not found';
const VIDEO_NOT_AVAILABLE_TEXT =
  'This video is not available, please try with a different one or perform a new search';
const LEAVE_ACCEPT = 'LEAVE';
const HOME_TEXT = 'Home';
const FINISHING_TIME_AFTER_START_TIME_ERROR = 'Finishing time must be after the start time';
const TIME_EXCEED_VIDEO_LENGTH = `The time you entered exceeds the video's length`;
const INVALID_TIME_FORMAT = 'Please review the format, it needs to be hh:mm:ss';
const RESET_PASSWORD_SUCCESSFUL_TITLE = 'Password updated';
const RESET_PASSWORD_SUCCESSFUL_DESCRIPTION = 'Your password has been updated correctly.';

// Login / Sign Up
const LOGIN = 'Login';
const SIGN_UP = 'Sign up';
const SIGN_UP_FORM_TITLE = 'CREATE YOUR ACCOUNT';
const SIGN_UP_FORM_DESCRIPTION = 'Enter your name, email, and create a strong password.';
const SIGN_IN_FORM_TITLE = 'WELCOME BACK';
const SIGN_IN_FORM_DESCRIPTION =
  'Enter your email and password to access your account and discover more videos.';
const SIGN_IN_SUCCESSFUL_TITLE = 'You have successfully logged in.';
const SIGN_UP_SUCCESSFUL_TITLE = 'Great! Registration success';
const SIGN_UP_SUCCESSFUL_DESCRIPTION =
  'Your account is now active. Start discovering premium videos, customize your searches, and take advantage of everything our platform has to offer.';

// Register
const REGISTER_DIALOG_TITLE = 'Leave page?';
const REGISTER_DIALOG_DESCRIPTION =
  'If you leave this page without creating your account, your changes will be lost. Are you sure you want to proceed?';
const REGISTER_DIALOG_BUTTON_TEXT_1 = 'Leave Page';
const REGISTER_DIALOG_BUTTON_TEXT_2 = 'Stay';

//Form
const FORM_ERROR_MESSAGE_TITLE = 'Sign-in failed';
const FORM_ERROR_MESSAGE_DESCRIPTION = 'We could not sign you in. Please review your details and try again.';

// Header
const HEADER_ALERT = 'There was a problem logging out. Please try again.';

// Input
const INPUT_ERROR_MESSAGE_1 = 'Email has already been taken';
const INPUT_ERROR_MESSAGE_2 =
  'This email address is already in use. Please try a different one or log in.';
const REQUIRED_FIELD = 'This field is required';
const INVALID_EMAIL_FORMAT = 'Invalid email format';
// Password
const RESET_PASSWORD_FORM_TITLE = 'RESET ACCOUNT PASSWORD';
const RESET_PASSWORD_FORM_DESCRIPTION =
  'Your new password must be different from previous used passwords.';
const RECOVER_PASSWORD_REQUEST_SEND_TITLE = 'Request Sent';
const RECOVER_PASSWORD_REQUEST_TITLE = 'Forgot Password';
const RECOVER_PASSWORD_DESCRIPTION =
  'Enter the email address associated with your account to receive a link to reset your password.';

// Other
const BACK = 'Back';
const CONTINUE = 'Continue';

const UNLOCK_VIDEO_CONTENT = 'Unlock Video Content';
const UNLOCK_VIDEO_CONTENT_MSG =
  'It looks like you’re not signed in. Please log in to watch the videos.';

const CONTRACT_AND_SIGN_TEXT = 'Contract and sign';
const CONTRACT_AND_SING_DISCLAIMER_TEXT =
  'Review your purchase details and the video usage contract before paying. Sign the contract to enable the “Proceed” button and proceed to checkout. After the payment you will be able to download and use the video';
const SIGNATURE_TEXT = 'Signature';
const SIGNATURE_DISCLAIMER_TEXT =
  'Please sign the contract to proceed. Click here to provide your signature';
const CHECKOUT_TEXT = 'Checkout';
const VIDEO_PURCHASE_DETAIL_TEXT = 'Video purchase detail';
const PRICE_DETAIL_TEXT = 'Price detail';
const SECOND_TEXT = 'Second';
const TOTAL_SECONDS_TEXT = 'Total Seconds';
const SIGN_TEXT = 'Sign';
const UPDATE_SIGNATURE_TEXT = 'Update Signature';
const COMPLETED_TEXT = 'Completed';
const PROCEED_TO_CHECKOUT_TEXT = 'Proceed to checkout';
const CONTRACT_DETAIL_TEXT = 'Contract detail';
const CLEAR_TEXT = 'Clear';
const SAVE_TEXT = 'Save';
const SIGN_LICENSING_AGREEMENT_TEXT = 'Sign Licensing Agreement';
const SIGN_LICENSING_AGREEMENT_DISCLAIMER_TEXT =
  'Please draw your signature and click "Save" to complete the process if you agree with the contract terms.';

const AGREED_AND_ACCEPTED_TEXT = 'Agreed and Accepted';
const DATE_TEXT = 'Date';
const PERMITTED_USAGE_TEXT = 'Permitted usage of licensed material';
const LICENSE_PERIOD_TEXT = 'License Period';
const NAME_TEXT = 'Name';
const EXHIBIT_A_TEXT = 'Exhibit A';

const LEAVE_CONTRACT_TITLE_TEXT = 'Leave purchase?';
const LEAVE_CONTRACT_DESCRIPTION_TEXT =
  'If you leave, your purchase will be lost. Are you sure you want to go?';
const STAY_TEXT = 'Stay';

export {
  PAGE_NAME,
  IMAGE_SCENE_TITLE,
  IMAGE_SCENE_DETAIL,
  TRANSCRIPTION_SCENE_TITLE,
  TRANSCRIPTION_SCENE_DETAIL,
  DESCRIPTION_SCENE_TITLE,
  DESCRIPTION_SCENE_DETAIL,
  VIEW_MORE_RESULTS,
  NEW_ICON_TEXT,
  ABOUT_US_TITLE,
  ABOUT_CODEWORD_HEADING,
  ABOUT_CODEWORD_BODY,
  PRIVACY_POLICY_TITLE,
  TERMS_AND_CONDITIONS_TITLE,
  COPYRIGHT_TEXT,
  BACK_TEXT,
  TITLE_HOME_P1,
  TITLE_HOME_P2,
  WAVE_TEXT,
  RESULTS,
  NO_RESULTS,
  NO_RESULTS_MSG,
  TOP_PICKS,
  BROWSE_COLLECTIONS_TITLE,
  TRENDING_TITLE,
  COLLECTION_BACK_TEXT,
  COLLECTION_VIDEO_SINGULAR_TEXT,
  COLLECTION_VIDEO_PLURAL_TEXT,
  COLLECTION_SHOWING_RECENT_TEXT,
  COLLECTION_EMPTY_TITLE_TEXT,
  COLLECTION_EMPTY_MSG_TEXT,
  COLLECTION_NOT_FOUND_TITLE_TEXT,
  COLLECTION_NOT_FOUND_MSG_TEXT,
  COLLECTION_ERROR_TITLE_TEXT,
  COLLECTION_ERROR_MSG_TEXT,
  COLLECTION_TILE_ACTION_PREFIX_TEXT,
  COLLECTION_TILE_ACTION_SUFFIX_TEXT,
  SEARCH_BAR_MSG,
  SEARCH_MIN_LENGTH_HINT,
  INVALID_SEARCH_DETECTED_TEXT,
  BACK,
  LOGOUT,
  LOGOUT_MSG,
  INVALID_SEARCH_MSG,
  MY_INFORMATION_DESCRIPTION,
  DIALOG_DESCRIPTION,
  MY_INFORMATION_INPUTS,
  MY_INFORMATION_SUBMIT,
  MY_INFORMATION,
  MY_ORDERS_DESCRIPTION,
  MY_ORDERS_NOTHING_TO_SEE,
  MY_ORDERS_SUBMIT,
  MY_ORDERS,
  ORDER_TEXT,
  VIEW_DETAILS_TEXT,
  MOST_RECENT_TEXT,
  OLDEST_TEXT,
  PAYMENT,
  PROFILE_GREETING,
  PROFILE_TITLE,
  SORT_BY_TEXT,
  BACK_TO_RESULTS_TEXT,
  VIDEO_ID_TEXT,
  DESCRIPTION_TEXT,
  TAGS_TEXT,
  FRAMES_FROM_VIDEOS_TEXT,
  SIMILAR_FRAMES_BADGE,
  SIMILAR_FRAMES_ARIA_LABEL,
  RESOLUTION_TEXT,
  MORE_DETAILED_INFORMATION_TEXT,
  FRAME_FOR_VIDEOS_TEXT,
  FILTER_BY_TEXT,
  NO_RESULTS_TEXT,
  NO_FRAMES_TEXT,
  ALL_SELECTOR_TEXT,
  VIDEO_SELECTOR_TEXT,
  AUDIO_SELECTOR_TEXT,
  TEXT_SELECTOR_TEXT,
  USD_CURRENCY,
  PRICE_TEXT,
  PRICE_LOADING_TEXT,
  PRICING_REQUEST_QUOTE_TEXT,
  PRICING_NOT_LICENSABLE_TEXT,
  PRICING_UNAVAILABLE_TEXT,
  ORDER_NOT_QUOTABLE_TEXT,
  ORDER_SUBMIT_FAILED_TEXT,
  PER_SECOND_TEXT,
  TOTAL_TEXT,
  SECONDS_TEXT,
  SECOND_SINGULAR_TEXT,
  BILLABLE_MINIMUM_NOTICE,
  MANUAL_REVIEW_DURATION_NOTICE,
  MANUAL_REVIEW_VALUE_NOTICE,
  ORDER_VALUE_LIMIT_TEXT,
  STARTING_TEXT,
  FINISHING_TEXT,
  SELECT_USAGE_TYPE_TEXT,
  ALL_MEDIA_TYPE_TEXT,
  ALL_MEDIA_PLUS_AI_TYPE_TEXT,
  TERRITORY_TEXT,
  TERRITORY_CHOOSE_TEXT,
  TERRITORY_HINT_TEXT,
  TERRITORY_REGIONS_TEXT,
  TERRITORY_COUNTRIES_TEXT,
  TERRITORY_OVERLAP_TEXT,
  TERRITORY_LIMIT_TEXT,
  TERRITORY_SUM_TEXT,
  TERRITORY_CAPPED_TEXT,
  TERRITORY_PICKER_LABEL,
  TERRITORY_USE_WORLDWIDE_TEXT,
  TERRITORY_SEARCH_WORLDWIDE_TEXT,
  TERRITORY_WORLDWIDE_INCLUDED_TEXT,
  TERRITORY_CHIP_CAPPED_TEXT,
  TERRITORY_SEARCH_LABEL,
  TERRITORY_SEARCH_PLACEHOLDER,
  TERRITORY_PICKS_LABEL,
  TERRITORY_REMOVE_TEXT,
  TERRITORY_PICK_TEXT,
  TERRITORY_PICK_CAPPED_TEXT,
  TERRITORY_ROW_PRICE_TEXT,
  TERRITORY_ROW_PRICE_CAPPED_TEXT,
  TERRITORY_REGION_KIND_TEXT,
  TERRITORY_COUNTRY_KIND_TEXT,
  TERRITORY_COUNTRY_IN_TEXT,
  TERRITORY_KIND_NOT_OFFERED_TEXT,
  TERRITORY_KIND_NOT_OFFERED_NOW_TEXT,
  TERRITORY_INCLUDED_IN_TEXT,
  TERRITORY_INCLUDES_TEXT,
  TERRITORY_ALREADY_ADDED_TEXT,
  TERRITORY_NO_MATCH_TEXT,
  TERRITORY_TO_ADD_TEXT,
  PERIOD_TEXT,
  PERIOD_DISCLAIMER,
  DOMESTIC_TEXT,
  DOMESTIC_AND_WORLDWIDE_TEXT,
  PERPETUITY_TEXT,
  ONE_YEAR_TEXT,
  BUY_NOW_TEXT,
  LICENSE_DISCLAIMER_TEXT,
  AI_USAGE_RESTRICTION_TEXT,
  PERIOD_DISCLAIMER_TEXT,
  PERIOD_DISCLAIMER_LABEL,
  PERPETUITY_DISCLAIMER_TEXT,
  SD,
  HD,
  FULL_HD,
  FOUR_K,
  VIDEO_NOT_FOUND_TEXT,
  VIDEO_NOT_AVAILABLE_TEXT,
  LEAVE_ACCEPT,
  HOME_TEXT,
  FINISHING_TIME_AFTER_START_TIME_ERROR,
  TIME_EXCEED_VIDEO_LENGTH,
  INVALID_TIME_FORMAT,
  LOGIN,
  SIGN_UP,
  REGISTER_DIALOG_TITLE,
  REGISTER_DIALOG_DESCRIPTION,
  REGISTER_DIALOG_BUTTON_TEXT_1,
  REGISTER_DIALOG_BUTTON_TEXT_2,
  FORM_ERROR_MESSAGE_TITLE,
  FORM_ERROR_MESSAGE_DESCRIPTION,
  HEADER_ALERT,
  INPUT_ERROR_MESSAGE_1,
  INPUT_ERROR_MESSAGE_2,
  SIGN_UP_FORM_TITLE,
  SIGN_UP_FORM_DESCRIPTION,
  SIGN_IN_FORM_TITLE,
  SIGN_IN_FORM_DESCRIPTION,
  SIGN_IN_SUCCESSFUL_TITLE,
  SIGN_UP_SUCCESSFUL_TITLE,
  SIGN_UP_SUCCESSFUL_DESCRIPTION,
  RESET_PASSWORD_SUCCESSFUL_TITLE,
  RESET_PASSWORD_SUCCESSFUL_DESCRIPTION,
  CONTINUE,
  RESET_PASSWORD_FORM_TITLE,
  RESET_PASSWORD_FORM_DESCRIPTION,
  RECOVER_PASSWORD_REQUEST_SEND_TITLE,
  RECOVER_PASSWORD_REQUEST_TITLE,
  RECOVER_PASSWORD_DESCRIPTION,
  UNLOCK_VIDEO_CONTENT,
  UNLOCK_VIDEO_CONTENT_MSG,
  USAGE_TYPE_TEXT,
  CONTRACT_AND_SIGN_TEXT,
  CONTRACT_AND_SING_DISCLAIMER_TEXT,
  SIGNATURE_TEXT,
  SIGNATURE_DISCLAIMER_TEXT,
  CHECKOUT_TEXT,
  VIDEO_PURCHASE_DETAIL_TEXT,
  PRICE_DETAIL_TEXT,
  SECOND_TEXT,
  TOTAL_SECONDS_TEXT,
  SIGN_TEXT,
  PROCEED_TO_CHECKOUT_TEXT,
  CONTRACT_DETAIL_TEXT,
  BACK_HOME_TEXT,
  CLEAR_TEXT,
  SAVE_TEXT,
  SIGN_LICENSING_AGREEMENT_TEXT,
  SIGN_LICENSING_AGREEMENT_DISCLAIMER_TEXT,
  UPDATE_SIGNATURE_TEXT,
  COMPLETED_TEXT,
  AGREED_AND_ACCEPTED_TEXT,
  DATE_TEXT,
  PERMITTED_USAGE_TEXT,
  LICENSE_PERIOD_TEXT,
  NAME_TEXT,
  EXHIBIT_A_TEXT,
  LEAVE_CONTRACT_TITLE_TEXT,
  LEAVE_CONTRACT_DESCRIPTION_TEXT,
  STAY_TEXT,
  REQUIRED_FIELD,
  PASSWD_MUST_BE_SAME,
  MY_ORDERS_DISCLAIMER_TEXT,
  BACK_TO_MY_ORDERS_TEXT,
  ORDER_DETAIL_TEXT,
  ORDER_MAIN_COMMENT,
  READY_TEXT,
  LOADING_TEXT,
  PAYMENT_CONFIRMING_TEXT,
  CLIP_PREPARING_TEXT,
  CLIP_FAILED_TEXT,
  CLIP_NOT_READY_TEXT,
  DOWNLOAD_VIDEO_TEXT,
  CONTRACT_LICENSING_TEXT,
  CONTRACT_LICENSING_DISCLAIMER_TEXT,
  VIEW_TEXT,
  SIGNED_CONTRACT_MISSING_TEXT,
  SIGNED_CONTRACT_FAILED_TEXT,
  SIGNED_CONTRACT_FILE_NAME,
  INVALID_EMAIL_FORMAT,
  NOT_COMPLETED_REQUEST,
  NOT_COMPLETED_REQUEST_MSG,
  SERVICE_UNAVAILABLE,
  SERVICE_UNAVAILABLE_MSG,
  PEOPLE_TEXT,
  TOPICS_TEXT,
  QUOTES_TEXT,
  SELECTED_MOMENT_TEXT,
  IN_THE_VIDEO_TEXT,
  MENTIONED_TEXT,
  SHOW_LESS_TEXT,
  TAGS_SHOW_ALL_LABEL,
  PEOPLE_SHOW_ALL_LABEL,
  VIDEO_DETAIL_UNAVAILABLE_TEXT,
  VIDEO_DETAIL_UNAVAILABLE_MSG,
  TRY_AGAIN_TEXT,
  VIDEO_STILL_PROCESSING_TEXT,
  VIDEO_PROCESSING_FAILED_TEXT
};

// Upload feature (Flow 1)
const UPLOAD_TITLE_TEXT = 'Upload your video';
const UPLOAD_SUBTITLE_TEXT =
  'Add source footage to your library. Files are processed automatically and become searchable across the platform.';
const UPLOAD_STEP_SELECT_TEXT = 'Select file';
const UPLOAD_STEP_DETAILS_TEXT = 'Details';
const UPLOAD_STEP_RIGHTS_TEXT = 'Rights';
const UPLOAD_STEP_DONE_TEXT = 'Done';
const UPLOAD_DROPZONE_TEXT = 'Drag & drop your video here';
const UPLOAD_DROPZONE_HINT_TEXT = 'or click to browse · MP4, MOV, MXF';
const UPLOAD_INVALID_TYPE_TEXT =
  'That file type isn’t supported. Please choose an MP4, MOV, or MXF file.';
const UPLOAD_CANCELLED_TEXT = 'Upload cancelled.';
const UPLOAD_DETAILS_TITLE_TEXT = 'Video details';
const UPLOAD_DETAILS_SUBTITLE_TEXT =
  'Tell us what this footage is. Good metadata makes your content easier to find and license.';
const UPLOAD_TITLE_LABEL = 'Title';
const UPLOAD_DESCRIPTION_LABEL = 'Description';
const UPLOAD_CATEGORY_LABEL = 'Category';
const UPLOAD_CATEGORY_PENDING_TEXT =
  'Category options are being finalized, free text for now';
const UPLOAD_EVENT_LOCATION_LABEL = 'Event / Location';
const UPLOAD_LIBRARY_LABEL = 'Library';
const UPLOAD_LIBRARY_LOCKED_TEXT = 'Set by your account';
const UPLOAD_RIGHTS_TITLE_TEXT = 'Rights & terms';
const UPLOAD_RIGHTS_SUBTITLE_TEXT =
  'Confirm you have the rights to add this footage to the platform.';
const UPLOAD_RIGHTS_ATTESTATION_TEXT =
  'I confirm that I own, or hold the necessary rights and clearances to, this footage, including any featured individuals, music and locations.';
const UPLOAD_RIGHTS_TERMS_TEXT =
  'I agree to the Content Licensing Terms and the Platform Terms & Conditions.';
const UPLOAD_SUBMIT_TEXT = 'Submit for processing';
const UPLOAD_DONE_TITLE_TEXT = 'You’re all set';
const UPLOAD_DONE_SUBTITLE_TEXT = 'has been submitted and is now processing.';
const UPLOAD_DONE_TIMING_TEXT =
  'Most videos are searchable in about 5-10 minutes. Longer videos can take 30 minutes or more.';
const UPLOAD_DONE_VIDEO_ID_TEXT = 'Video ID';
const UPLOAD_COPY_ID_TEXT = 'Copy video ID';
const UPLOAD_COPIED_TEXT = 'Copied!';
const UPLOAD_VIEW_MY_UPLOADS_TEXT = 'View my uploads';
const UPLOAD_ANOTHER_TEXT = 'Upload another';
const UPLOAD_CANCEL_TEXT = 'Cancel upload';
const UPLOAD_RETRY_TEXT = 'Retry';
const UPLOAD_ERROR_TITLE_TEXT = 'Upload problem';
const UPLOAD_CANCEL_DIALOG_TITLE_TEXT = 'Cancel this upload?';
const UPLOAD_CANCEL_DIALOG_DESCRIPTION_TEXT =
  'The upload will stop and the selected file will be discarded.';
const UPLOAD_LEAVE_TITLE_TEXT = 'Leave upload?';
const UPLOAD_LEAVE_DESCRIPTION_TEXT =
  'Your upload is still in progress. If you leave now it will be cancelled and you’ll have to start again.';
const MY_UPLOADS_TITLE_TEXT = 'My uploads';
const USER_GUIDE_TEXT = 'User guide';
const USER_GUIDE_NEW_TAB_TEXT = '(opens in a new tab)';
const MY_UPLOADS_SUBTITLE_TEXT =
  'Everything you’ve added, and where it is in the pipeline.';
const MY_UPLOADS_COL_VIDEO_TEXT = 'Video';
const MY_UPLOADS_COL_UPLOADED_TEXT = 'Uploaded';
const MY_UPLOADS_COL_OWNER_TEXT = 'Uploaded by';
const MY_UPLOADS_COL_STATUS_TEXT = 'Status';
const MY_UPLOADS_EMPTY_TITLE_TEXT = 'No uploads yet';
const MY_UPLOADS_EMPTY_MSG_TEXT =
  'Videos you upload will appear here with their processing status.';
const MY_UPLOADS_STATUS_NOTE_TEXT =
  'Live status coming soon. Uploads show their last known state.';
const MY_UPLOADS_REFRESH_TEXT = 'Refresh';
// Progress copy. Written for a licensing coordinator, not an engineer: no
// pipeline vocabulary, no internal concepts (no keyframes, indexing,
// embeddings, annotation, metadata), and no two consecutive steps sharing a
// verb, so movement between them reads as movement.
const MY_UPLOADS_STEP_TEXT = 'Step';
const MY_UPLOADS_OF_TEXT = 'of';
const MY_UPLOADS_SEARCHABLE_TEXT = 'Searchable now';
const MY_UPLOADS_SEARCHABLE_TOOLTIP_TEXT =
  'You can already find this video in search. It is still finishing up.';
const MY_UPLOADS_STOPPED_AT_TEXT = 'Stopped at';
const MY_UPLOADS_CHECKING_FILE_TEXT = 'Checking the file';
// Scan-phase + verdict + poll-issue copy (wiring item 4). User-safe by rule:
// scanner internals (signatures, byte counts) are never shown.
const UPLOAD_SCANNING_TOOLTIP_TEXT = 'Being checked before processing starts.';
const UPLOAD_FAILED_INFECTED_TEXT =
  'This file failed a security scan and was not published.';
const UPLOAD_FAILED_OVERSIZED_TEXT = 'This file exceeds the maximum allowed size.';
// Tooltips for the "Checking..." chip. These describe the USER's situation, not
// the system's: in every one of these cases the upload succeeded and the video
// is processing normally - only the status poll has not resolved. The previous
// copy ("could not be reached", "not authorized", "could not be found") read as
// though the video were at risk, which invites someone to re-upload a video
// that is already being processed.
//
// Three of the four collapse to the same line because from the user's side they
// are the same event. Only the auth case differs, because signing in again
// genuinely fixes it - and even there the second sentence removes the fear.
const STATUS_ISSUE_UNREACHABLE_TEXT = 'Still checking. Your video is processing normally.';
const STATUS_ISSUE_UNAUTHORIZED_TEXT = 'Sign in again to see live updates. Your video is unaffected.';
const STATUS_ISSUE_NOTFOUND_TEXT = 'Still checking. Your video is processing normally.';
const STATUS_ISSUE_SERVER_TEXT = 'Still checking. Your video is processing normally.';

export {
  UPLOAD_TITLE_TEXT,
  UPLOAD_SUBTITLE_TEXT,
  UPLOAD_STEP_SELECT_TEXT,
  UPLOAD_STEP_DETAILS_TEXT,
  UPLOAD_STEP_RIGHTS_TEXT,
  UPLOAD_STEP_DONE_TEXT,
  UPLOAD_DROPZONE_TEXT,
  UPLOAD_DROPZONE_HINT_TEXT,
  UPLOAD_INVALID_TYPE_TEXT,
  UPLOAD_CANCELLED_TEXT,
  UPLOAD_DETAILS_TITLE_TEXT,
  UPLOAD_DETAILS_SUBTITLE_TEXT,
  UPLOAD_TITLE_LABEL,
  UPLOAD_DESCRIPTION_LABEL,
  UPLOAD_CATEGORY_LABEL,
  UPLOAD_CATEGORY_PENDING_TEXT,
  UPLOAD_EVENT_LOCATION_LABEL,
  UPLOAD_LIBRARY_LABEL,
  UPLOAD_LIBRARY_LOCKED_TEXT,
  UPLOAD_RIGHTS_TITLE_TEXT,
  UPLOAD_RIGHTS_SUBTITLE_TEXT,
  UPLOAD_RIGHTS_ATTESTATION_TEXT,
  UPLOAD_RIGHTS_TERMS_TEXT,
  UPLOAD_SUBMIT_TEXT,
  UPLOAD_DONE_TITLE_TEXT,
  UPLOAD_DONE_SUBTITLE_TEXT,
  UPLOAD_DONE_TIMING_TEXT,
  UPLOAD_DONE_VIDEO_ID_TEXT,
  UPLOAD_COPY_ID_TEXT,
  UPLOAD_COPIED_TEXT,
  UPLOAD_VIEW_MY_UPLOADS_TEXT,
  UPLOAD_ANOTHER_TEXT,
  UPLOAD_CANCEL_TEXT,
  UPLOAD_RETRY_TEXT,
  UPLOAD_ERROR_TITLE_TEXT,
  UPLOAD_CANCEL_DIALOG_TITLE_TEXT,
  UPLOAD_CANCEL_DIALOG_DESCRIPTION_TEXT,
  UPLOAD_LEAVE_TITLE_TEXT,
  UPLOAD_LEAVE_DESCRIPTION_TEXT,
  MY_UPLOADS_TITLE_TEXT,
  USER_GUIDE_TEXT,
  USER_GUIDE_NEW_TAB_TEXT,
  MY_UPLOADS_SUBTITLE_TEXT,
  MY_UPLOADS_COL_VIDEO_TEXT,
  MY_UPLOADS_COL_UPLOADED_TEXT,
  MY_UPLOADS_COL_OWNER_TEXT,
  MY_UPLOADS_COL_STATUS_TEXT,
  MY_UPLOADS_EMPTY_TITLE_TEXT,
  MY_UPLOADS_EMPTY_MSG_TEXT,
  MY_UPLOADS_STATUS_NOTE_TEXT,
  MY_UPLOADS_REFRESH_TEXT,
  MY_UPLOADS_STEP_TEXT,
  MY_UPLOADS_OF_TEXT,
  MY_UPLOADS_SEARCHABLE_TEXT,
  MY_UPLOADS_SEARCHABLE_TOOLTIP_TEXT,
  MY_UPLOADS_STOPPED_AT_TEXT,
  MY_UPLOADS_CHECKING_FILE_TEXT,
  UPLOAD_SCANNING_TOOLTIP_TEXT,
  UPLOAD_FAILED_INFECTED_TEXT,
  UPLOAD_FAILED_OVERSIZED_TEXT,
  STATUS_ISSUE_UNREACHABLE_TEXT,
  STATUS_ISSUE_UNAUTHORIZED_TEXT,
  STATUS_ISSUE_NOTFOUND_TEXT,
  STATUS_ISSUE_SERVER_TEXT,
};

// Add Content shell (mode chooser)
const ADD_CONTENT_TITLE_TEXT = 'Add content';
const ADD_CONTENT_SUBTITLE_TEXT = 'Add source footage to your library.';
const ADD_CONTENT_INCREMENTAL_TITLE = 'Upload videos';
const ADD_CONTENT_INCREMENTAL_DESC = 'Add one or a handful of files straight from this browser.';
// Bulk-import copy retained for when the chooser is restored (bulk becomes real).
const ADD_CONTENT_BULK_TITLE = 'Bulk media import';
const ADD_CONTENT_BULK_DESC = 'Connect cloud storage and bring across an entire back catalogue.';
const ADD_CONTENT_BULK_DEFERRED = 'Coming soon';
const ADD_CONTENT_CONTINUE_TEXT = 'Continue';

// Licensor onboarding
const ONBOARDING_TITLE_TEXT = 'Licensor onboarding';
const ONBOARDING_STEP_DETAILS_TEXT = 'Licensor';
const ONBOARDING_STEP_PRICING_TEXT = 'Pricing';
const ONBOARDING_STEP_RIGHTS_TEXT = 'Rights';
const ONBOARDING_STEP_REVIEW_TEXT = 'Review';
const ONBOARDING_STEP_DONE_TEXT = 'Done';
const ONBOARDING_DETAILS_TITLE_TEXT = 'Licensor details';
const ONBOARDING_DETAILS_SUBTITLE_TEXT =
  'Set up a new rights holder. You will define their library, how their content is priced, and what licensees are allowed to do with it.';
const ONBOARDING_ORG_LABEL = 'Organisation name';
const ONBOARDING_LIBRARY_LABEL = 'Library name';
const ONBOARDING_CONTACT_LABEL = 'Primary contact';
const ONBOARDING_EMAIL_LABEL = 'Contact email';
const ONBOARDING_VISIBILITY_LABEL = 'Library visibility';
const ONBOARDING_VISIBILITY_CLOSED = 'Closed library';
const ONBOARDING_VISIBILITY_OPEN = 'Open to all licensees';
const ONBOARDING_VISIBILITY_HELP =
  'Controls whether other licensees on the platform can discover this content.';
const ONBOARDING_PRICING_TITLE_TEXT = 'Pricing';
// The pricing step is a DISCLOSURE, not a form, and it now shows NO NUMBERS.
//
// It used to render a three-tier rate card read from a table in the bundle.
// There is no tier dimension in the charging model, and rates are
// owner-controlled data that changes without a deploy, so any figure printed
// here would have been both wrong and liable to go stale silently. Describing
// the model in words is accurate, cannot drift, and needs no fetch into a
// wizard that persists nothing.
//
// Decided 2026-09-01 by Vanja and RJ. Do not reintroduce a number, a tier name,
// or anything implying tiers exist.
const ONBOARDING_PRICING_SUBTITLE_TEXT =
  'How your content is priced on the platform.';
const ONBOARDING_TIERS_LABEL = 'Pricing';
const ONBOARDING_PRICING_DISCLOSURE_HELP =
  'Clips are licensed by the second. The rate depends on the usage type, the ' +
  'territory and the licence period the buyer chooses, and a three-second ' +
  'minimum applies to every clip. Your own rates are agreed with Young ' +
  'Hollywood separately and are configured by the platform, so there is ' +
  'nothing to set here.';
// SUPERSEDED 2026-08-11 and removed: per-licensor rate fields, the bespoke
// tier, duration price breaks and volume discounts.
//
// CORRECTED 2026-09-01: this note used to end "and Vanja's decision made the
// three-tier matrix authoritative". That is no longer true and should not be
// read as licence to keep a tier model alive. The charging model is eight keys
// of usage, territory and period, with NO tier dimension, and the rates are
// owner-editable data in the pricing service rather than anything in this
// bundle. The removed
// help line - "Longer clips and larger orders attract a lower effective rate.
// Applied automatically at checkout." - described a discount that was never
// applied at checkout by anything. Do not reintroduce these.
const ONBOARDING_RIGHTS_TITLE_TEXT = 'Rights and terms';
const ONBOARDING_RIGHTS_SUBTITLE_TEXT = 'These become the default terms on every licence issued from this library.';
const ONBOARDING_AI_LABEL = 'AI modification';
const ONBOARDING_AI_APPROVAL = 'Allowed, with approval';
const ONBOARDING_AI_NO_APPROVAL = 'Allowed, no approval needed';
const ONBOARDING_AI_NOT_ALLOWED = 'Not allowed';
const ONBOARDING_TERM_LABEL = 'Licence term';
const ONBOARDING_TERM_1Y = '1 year';
const ONBOARDING_TERM_PERP = 'In perpetuity';
const ONBOARDING_TERRITORY_LABEL = 'Territory';
const ONBOARDING_TERRITORY_WORLDWIDE = 'Worldwide';
const ONBOARDING_TERRITORY_US = 'Domestic (US)';
const ONBOARDING_GENERAL_TERMS_LABEL = 'General licensing terms';
const ONBOARDING_GENERAL_TERMS_TEXT =
  'Ownership stays with the licensor. Term and territory apply on payment. AI modifications are submitted with a hash for sign off. Each asset carries attribution. Withdrawal rights apply. Rates are reviewed annually.';
const ONBOARDING_ACCEPT_TERMS_TEXT = 'I accept these default licensing terms on behalf of the licensor.';
const ONBOARDING_REVIEW_TITLE_TEXT = 'Review';
const ONBOARDING_REVIEW_SUBTITLE_TEXT = 'Everything here can be changed later from the admin back office.';
const ONBOARDING_CREATE_TEXT = 'Create licensor';
const ONBOARDING_DONE_TITLE_TEXT = 'Licensor created';
const ONBOARDING_DONE_INVITE_TEXT = 'An invitation has been sent. They can now upload content. Their rates are agreed separately and configured by the platform.';
const ONBOARDING_DONE_ANOTHER_TEXT = 'Onboard another licensor';
const ONBOARDING_DONE_GO_UPLOAD_TEXT = 'Go to content upload';
const ONBOARDING_PARTNER_ID_TEXT = 'Partner ID';
const ONBOARDING_LEAVE_TITLE_TEXT = 'Leave onboarding?';
const ONBOARDING_LEAVE_DESCRIPTION_TEXT =
  'Your onboarding progress will be lost if you leave now. Are you sure you want to go?';

export {
  ADD_CONTENT_TITLE_TEXT,
  ADD_CONTENT_SUBTITLE_TEXT,
  ADD_CONTENT_INCREMENTAL_TITLE,
  ADD_CONTENT_INCREMENTAL_DESC,
  ADD_CONTENT_BULK_TITLE,
  ADD_CONTENT_BULK_DESC,
  ADD_CONTENT_BULK_DEFERRED,
  ADD_CONTENT_CONTINUE_TEXT,
  ONBOARDING_TITLE_TEXT,
  ONBOARDING_STEP_DETAILS_TEXT,
  ONBOARDING_STEP_PRICING_TEXT,
  ONBOARDING_STEP_RIGHTS_TEXT,
  ONBOARDING_STEP_REVIEW_TEXT,
  ONBOARDING_STEP_DONE_TEXT,
  ONBOARDING_DETAILS_TITLE_TEXT,
  ONBOARDING_DETAILS_SUBTITLE_TEXT,
  ONBOARDING_ORG_LABEL,
  ONBOARDING_LIBRARY_LABEL,
  ONBOARDING_CONTACT_LABEL,
  ONBOARDING_EMAIL_LABEL,
  ONBOARDING_VISIBILITY_LABEL,
  ONBOARDING_VISIBILITY_CLOSED,
  ONBOARDING_VISIBILITY_OPEN,
  ONBOARDING_VISIBILITY_HELP,
  ONBOARDING_PRICING_TITLE_TEXT,
  ONBOARDING_PRICING_SUBTITLE_TEXT,
  ONBOARDING_TIERS_LABEL,
  ONBOARDING_PRICING_DISCLOSURE_HELP,

  ONBOARDING_RIGHTS_TITLE_TEXT,
  ONBOARDING_RIGHTS_SUBTITLE_TEXT,
  ONBOARDING_AI_LABEL,
  ONBOARDING_AI_APPROVAL,
  ONBOARDING_AI_NO_APPROVAL,
  ONBOARDING_AI_NOT_ALLOWED,
  ONBOARDING_TERM_LABEL,
  ONBOARDING_TERM_1Y,
  ONBOARDING_TERM_PERP,
  ONBOARDING_TERRITORY_LABEL,
  ONBOARDING_TERRITORY_WORLDWIDE,
  ONBOARDING_TERRITORY_US,
  ONBOARDING_GENERAL_TERMS_LABEL,
  ONBOARDING_GENERAL_TERMS_TEXT,
  ONBOARDING_ACCEPT_TERMS_TEXT,
  ONBOARDING_REVIEW_TITLE_TEXT,
  ONBOARDING_REVIEW_SUBTITLE_TEXT,
  ONBOARDING_CREATE_TEXT,
  ONBOARDING_DONE_TITLE_TEXT,
  ONBOARDING_DONE_INVITE_TEXT,
  ONBOARDING_DONE_ANOTHER_TEXT,
  ONBOARDING_DONE_GO_UPLOAD_TEXT,
  ONBOARDING_PARTNER_ID_TEXT,
  ONBOARDING_LEAVE_TITLE_TEXT,
  ONBOARDING_LEAVE_DESCRIPTION_TEXT,
};

// Content Licensing Agreement (verbatim legal asset)
const LICENSE_AGREEMENT_TITLE_TEXT = 'Content Licensing Agreement';
const LICENSE_AGREEMENT_ACCEPT_TEXT = 'I have read and agree to the Content Licensing Agreement.';
const LICENSE_AGREEMENT_SECTION_TITLE = 'Licence agreement';

export {
  LICENSE_AGREEMENT_TITLE_TEXT,
  LICENSE_AGREEMENT_ACCEPT_TEXT,
  LICENSE_AGREEMENT_SECTION_TITLE,
};

// The Contract and sign page and the checkout pages after the 2026-10 redesign.
// NEW WORDING, written by the build session. Vanja owns every string in this
// block: replace the values, keep the names.
//   CONTRACT_OPEN_FULL_SIZE_TEXT  opens the contract in its own tab
//   CONTRACT_DOWNLOAD_TEXT        saves the contract (the signed copy, once signed)
//   CONTRACT_CANNOT_SHOW_TEXT     shown in place of the contract where a browser
//                                 cannot draw a PDF inside a page
//   CONTRACT_SIGNING_FAILED_TEXT  the signature could not be put on the contract
//   SIGNATURE_IMAGE_ALT_TEXT      names the drawn signature for a screen reader
const CONTRACT_OPEN_FULL_SIZE_TEXT = 'Open full size';
const CONTRACT_DOWNLOAD_TEXT = 'Download PDF';
const CONTRACT_CANNOT_SHOW_TEXT =
  'This browser cannot show the contract on this page. Open it full size or download it to read it.';
const CONTRACT_SIGNING_FAILED_TEXT =
  'We could not add your signature to the contract. Please sign again.';
const SIGNATURE_IMAGE_ALT_TEXT = 'Your signature';

export {
  CONTRACT_OPEN_FULL_SIZE_TEXT,
  CONTRACT_DOWNLOAD_TEXT,
  CONTRACT_CANNOT_SHOW_TEXT,
  CONTRACT_SIGNING_FAILED_TEXT,
  SIGNATURE_IMAGE_ALT_TEXT,
};

// The quote request (2026-10-13): the button that takes Buy Now's place when
// an order cannot be bought online, the short form it opens over the video
// page, and the email that form makes.
// NEW WORDING, written by the build session. Vanja owns every string in this
// block: replace the values, keep the names. The address a request goes to is
// NOT here; it is one constant in api/quoteRequest/config.ts.
const REQUEST_QUOTE_TEXT = 'Request a quote';
const QUOTE_REQUESTED_TEXT = 'Quote requested';
// Today's over-the-limit notice (MANUAL_REVIEW_VALUE_NOTICE), cut after its
// first sentence. Its second sentence tells the buyer to write to an address,
// and inside the form the form is what they use instead.
const QUOTE_VALUE_REASON = (thresholdUsd: number): string =>
  `Orders over $${thresholdUsd.toLocaleString('en-US')} are arranged directly rather than through checkout.`;
const QUOTE_COMPANY_LABEL = 'Company (the licensee)';
const QUOTE_PROJECT_LABEL = 'Project';
const QUOTE_USE_LABEL = 'How the clip will be used';
// With whichever of the two the account holds; nothing at all when it holds
// neither (the form then leaves the line out).
const QUOTE_SENT_FROM = (name: string, email: string): string => {
  const who = [name, email].map((part) => part.trim()).filter(Boolean).join(', ');
  return who ? `Sent from ${who}.` : '';
};
const QUOTE_CANCEL_TEXT = 'Cancel';
const QUOTE_SEND_TEXT = 'Send request';
const QUOTE_DONE_TEXT = 'Done';
// After Send, when the request really was sent (mock and live modes).
const QUOTE_SENT_PILL_TEXT = 'Request sent';
const QUOTE_SENT_TITLE = 'Your quote request has been sent to Young Hollywood';
const QUOTE_SENT_BODY =
  'They have the clip details and your contact details. Nothing has been charged and the clip is not licensed yet.';
const QUOTE_SENT_TO_LABEL = 'Sent to';
const QUOTE_REPLY_TO_LABEL = 'Reply to';
// After Send, when the message was handed to the buyer's own email program.
// Nothing has been sent at that point, so none of these may say it has.
const QUOTE_EMAIL_TITLE = 'Finish sending in your email program';
const QUOTE_EMAIL_BODY = (address: string): string =>
  `Your email program should have opened with the request ready, addressed to ${address}. Press send there to send it. Nothing has been charged and the clip is not licensed yet.`;
const QUOTE_EMAIL_FALLBACK = (address: string): string =>
  `If nothing opened, copy the details and email them to ${address}.`;
const QUOTE_COPY_TEXT = 'Copy the details';
const QUOTE_COPIED_TEXT = 'Copied';
const QUOTE_COPY_BOX_LABEL = 'The details to copy';
const QUOTE_FAILED = (address: string): string =>
  `We could not send your request. Please try again, or email ${address}.`;
// The email itself. The buyer sees these in their own email program.
const QUOTE_EMAIL_SUBJECT = (title: string): string => `Quote request: ${title}`;
const QUOTE_EMAIL_INTRO = 'A quote request from the Codeword site.';
const QUOTE_EMAIL_REASON_LABEL = 'Why a quote is needed';
const QUOTE_EMAIL_REASONS: Record<string, string> = {
  over_order_value: 'the order is over the limit for online checkout',
  over_clip_length: 'the clip is over the length limit for online checkout',
  priced_on_request: 'the video is priced on request',
};
const QUOTE_EMAIL_FROM_HEADING = 'From';

export {
  REQUEST_QUOTE_TEXT,
  QUOTE_REQUESTED_TEXT,
  QUOTE_VALUE_REASON,
  QUOTE_COMPANY_LABEL,
  QUOTE_PROJECT_LABEL,
  QUOTE_USE_LABEL,
  QUOTE_SENT_FROM,
  QUOTE_CANCEL_TEXT,
  QUOTE_SEND_TEXT,
  QUOTE_DONE_TEXT,
  QUOTE_SENT_PILL_TEXT,
  QUOTE_SENT_TITLE,
  QUOTE_SENT_BODY,
  QUOTE_SENT_TO_LABEL,
  QUOTE_REPLY_TO_LABEL,
  QUOTE_EMAIL_TITLE,
  QUOTE_EMAIL_BODY,
  QUOTE_EMAIL_FALLBACK,
  QUOTE_COPY_TEXT,
  QUOTE_COPIED_TEXT,
  QUOTE_COPY_BOX_LABEL,
  QUOTE_FAILED,
  QUOTE_EMAIL_SUBJECT,
  QUOTE_EMAIL_INTRO,
  QUOTE_EMAIL_REASON_LABEL,
  QUOTE_EMAIL_REASONS,
  QUOTE_EMAIL_FROM_HEADING,
};

// Agentic search (search-agent integration)
// Staged progress copy. NONE of it claims to know what the service is doing.
// The frontend cannot see inside a search: search-agent returns one JSON body
// when its whole Plan -> Execute -> Enrich -> Evaluate loop finishes, and no
// stage boundary or retry is observable until the response arrives. Copy that
// names an internal stage is therefore a guess presented to the user as fact,
// and it is wrong whenever the guess is wrong. These three lines are true at
// any elapsed time and under any internal state.
const AGENTIC_SEARCHING_TEXT = 'Searching library...';
const AGENTIC_STILL_SEARCHING_TEXT = 'Still searching. This can take a few more seconds.';
const AGENTIC_TAKING_LONGER_TEXT = 'Still searching. You can cancel and try different wording.';
const AGENTIC_CANCEL_TEXT = 'Cancel search';
// Accessible name for the indeterminate progress indicator. Deliberately not the
// staged copy, which sits in its own aria-live region right beside it - reusing
// it would have a screen reader say the same sentence twice.
const AGENTIC_PROGRESS_LABEL = 'Search progress';
const SEARCHED_AS_TEXT = 'Searched as';
// Shown above the results only when search-agent retried with other words
// because its first attempt found none or very few close matches (Vanja,
// 2026-09-28, item 6: "singers" became "famous singers", "sunrise" became
// sunsets). noneKept says which: the first attempt kept nothing, or kept a
// few that were set aside for the retry. A one-attempt planner rewrite shows
// nothing, so SEARCHED_AS_TEXT is not rendered while this stands. Wording, and
// whether to hide rewrites, pending Vanja.
const AGENTIC_RETRY_NOTICE = (typed: string, used: string, noneKept: boolean): string =>
  `${noneKept ? 'No' : 'Few'} close matches for "${typed}". Showing results for "${used}" instead.`;
// Shown above the results when nothing matched and the closest results are
// shown instead (confident: false). The sentence only, never with the
// service's own reasoning after it (2026-10-14): that text can say "no strong
// match", and the Strong / Likely / Possible labels are no longer shown.
// Shortened on 20 Oct from "We couldn’t find an exact match. Here are the
// closest results."
const AGENTIC_LOW_CONFIDENCE_MSG = 'Closest results';
// Labels a video with no title under its card. (The two "Matched ..." hover
// lines of 2026-09-29 were removed 2026-10-14: a card whose moment has no
// text shows the video's description instead, or nothing.)
const AGENTIC_UNTITLED_MOMENT = 'Untitled moment';
// Top-left tag on each search result card (2026-09-24 demo): whether the
// person searched for is on camera in the video or only talked about in it.
// Wording is pending Young Hollywood's confirmation. Kept apart from
// MENTIONED_TEXT on purpose: that one also labels the people lists on the card
// and the detail page, which a change to this tag's wording must not move.
// The In video / Mentioned filter tabs read these too, so tab and tag always
// say the same thing.
const AGENTIC_IN_VIDEO_TAG = 'In Video';
const AGENTIC_MENTIONED_TAG = 'Mentioned';
// A result on a search that names a person which the search kept but whose video's own people lists do not
// name that person in full (a stage name such as "MAX" for Max Schneider, a first name only), so the service
// could not say In Video or Mentioned (2026-10-17). It is shown rather than hidden: the search judged it a match.
// Wording is pending Young Hollywood's confirmation, like the two tags above.
const AGENTIC_UNCONFIRMED_TAG = 'Unconfirmed';

export {
  AGENTIC_SEARCHING_TEXT,
  AGENTIC_STILL_SEARCHING_TEXT,
  AGENTIC_TAKING_LONGER_TEXT,
  AGENTIC_CANCEL_TEXT,
  AGENTIC_PROGRESS_LABEL,
  SEARCHED_AS_TEXT,
  AGENTIC_RETRY_NOTICE,
  AGENTIC_LOW_CONFIDENCE_MSG,
  AGENTIC_UNTITLED_MOMENT,
  AGENTIC_IN_VIDEO_TAG,
  AGENTIC_MENTIONED_TAG,
  AGENTIC_UNCONFIRMED_TAG,
};

// RJ's revised homepage (20 Oct). Copy word for word from the client's
// package (ops/homepage-revised-1020-analysis-2026-10-20/inventory.md): the
// sub line and the four features from the mockup, the two cards from the
// Navigation Flow's "Homepage card copy". One wording change, approved by Joey
// on 20 Oct (Q12) and listed for Vanja: the mockup's "assitance" is
// "assistance" here.
const HOME_SUB_LINE = 'Codeword is an AI-powered marketplace for premium, hard-to-find video.';
const HOME_FEATURE_LIBRARIES_TITLE = 'Premium Content Libraries';
const HOME_FEATURE_LIBRARIES_TEXT = 'Access curated, high-quality footage from leading creators.';
const HOME_FEATURE_RIGHTS_TITLE = 'Clear Rights & Ownership';
const HOME_FEATURE_RIGHTS_TEXT = 'Understand permissions and licensing with confidence.';
const HOME_FEATURE_LICENSE_TITLE = 'License Only What You Need';
const HOME_FEATURE_LICENSE_TEXT = 'Get the exact seconds you need for your project.';
const HOME_FEATURE_AI_TITLE = 'AI-Assisted Creation';
const HOME_FEATURE_AI_TEXT = "Reimagine footage with approved AI assistance and the owner's permission.";
const HOME_CARD_BUYERS_TITLE = 'For Buyers';
const HOME_CARD_BUYERS_TEXT = 'Find exact moments, license only what you need, and create with confidence.';
const HOME_CARD_OWNERS_TITLE = 'For Content Owners';
const HOME_CARD_OWNERS_TEXT = 'Organize archives, manage approvals, and unlock new revenue from valuable footage.';

export {
  HOME_SUB_LINE,
  HOME_FEATURE_LIBRARIES_TITLE,
  HOME_FEATURE_LIBRARIES_TEXT,
  HOME_FEATURE_RIGHTS_TITLE,
  HOME_FEATURE_RIGHTS_TEXT,
  HOME_FEATURE_LICENSE_TITLE,
  HOME_FEATURE_LICENSE_TEXT,
  HOME_FEATURE_AI_TITLE,
  HOME_FEATURE_AI_TEXT,
  HOME_CARD_BUYERS_TITLE,
  HOME_CARD_BUYERS_TEXT,
  HOME_CARD_OWNERS_TITLE,
  HOME_CARD_OWNERS_TEXT,
};
